import 'protons';
import './_wizard-application-entrant.twig';
import { createWizard } from 'clientside/wizard';
import { submitApplication, trackingOnStepChange } from 'clientside/wizard/api';
import template from './template.vue';

export const name = 'wizard-application-entrant';

export const defaults = {};

export function disable() {}

export function enable(context) {
  const el = context.querySelector('#wizard-application-entrant');
  if (!el) return;

  const elConfig = JSON.parse(el.dataset.config);
  const { publicationid, jobid, apiendpoint, otherjobs } = elConfig;

  createWizard({
    el,
    name: 'Entrant',
    template,
    async onSubmit({ data }) {
      return submitApplication(apiendpoint, jobid, publicationid, data);
    },
    onStepChange({ fromStep, toStep }) {
      trackingOnStepChange(toStep);
      console.log(`Changed from step ${fromStep} to step ${toStep}.`);
    },
    additionalOptionSets: {
      otherJobs: otherjobs,
    },
  });
}

export default enable;
